const fields = (excludedDates, excludedStartDates, excludedEndDates) => {
  return {
    config: { columns: 1 },
    fields: [
      {
        name: 'dates',
        label: 'Wybierz zakres dat',
        column: 1,
        type: 'dateRange',
        mandatory: true,
        startField: 'startDate',
        endField: 'endDate',
        excludedDates: excludedDates?.map(date => new Date(date)),
        excludedStartDates: excludedStartDates?.map(date => new Date(date)),
        excludedEndDates: excludedEndDates?.map(date => new Date(date))
      },
      {
        name: 'adults',
        label: 'Dorośli',
        column: 1,
        type: 'counter',
        mandatory: true,
      },
      {
        name: 'children',
        label: 'Dzieci',
        column: 1,
        type: 'counter',
      },
      {
        name: 'infants',
        label: 'Małe dzieci',
        column: 1,
        type: 'counter',
      },
    ],
  };
};

export default fields;
